module.exports = __webpack_public_path__ + "static/img/inforImgLeft.9c12728.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inforImgLeft.jpg
// module id = DyoN
// module chunks = 2